import React from "react";
import OnboardingLayout from "./OnboardingLayout";
import "../../Animations.css";
import NoPaymentText from "../NoPaymentText";
import parrotdemo from "@/assets/suset-onboarding-720p.mp4";
import iphone from "@/assets/iphone.png";

interface FreeTrialProps {
  platform: string;
  assetSources?: {
    parrotDemo: string;
    iphone: string;
  };
}

const FreeTrial: React.FC<FreeTrialProps> = ({ platform, assetSources }) => {
  return (
    <OnboardingLayout
      title={
        <span className="flex text-center items-center justify-center flex-col">
          <span>We want you to</span>
          <span>try Parrot for FREE</span>
        </span>
      }
      subtitle={
        <div
          className="inline-block px-3 py-1.5 rounded-full bg-blue-50/70 text-[var(--color-blue)] text-sm"
          style={{
            boxShadow:
              "0 1px 4px -1px rgba(0,122,255,0.12), inset 0 1px 0px 0px rgba(255,255,255,0.6)",
          }}
        >
          <div className="flex flex-row items-center justify-center gap-1.5 text-[var(--color-blue)]">
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <svg
                  key={i}
                  className="w-[14px] h-[14px]"
                  viewBox="0 0 24 24"
                  fill={i < 4 || i === 4 ? "#007AFF" : "#D1D1D6"}
                >
                  <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" />
                </svg>
              ))}
            </div>
            <div className="leading-tight">
              <span className="font-medium">4.9</span>
              <span className="text-[var(--color-blue)]/70 text-sm">
                {" "}
                • App Store Rating
              </span>
            </div>
          </div>
        </div>
      }
      classname="text-center items-center justify-center"
    >
      <div className="flex flex-col h-full w-full justify-between items-center overflow-y-hidden">
        <div className="flex-grow flex flex-col h-full w-full items-center justify-center relative">
          <div
            className={`relative ${
              platform === "web" ? "phone-width" : "w-[250px]"
            }`}
          >
            <img
              src={assetSources?.iphone || iphone}
              alt="iPhone Preview"
              className={`w-full h-auto object-contain`}
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <video
                className={`w-[83.15%] h-auto object-cover pt-[1.2%] pb-[1.3%] overflow-hidden`}
                style={{
                  borderRadius: "13% / 7%",
                }}
                src={assetSources?.parrotDemo || parrotdemo}
                autoPlay
                muted
                loop
                playsInline
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>

        <NoPaymentText />
      </div>
    </OnboardingLayout>
  );
};

export default FreeTrial;
